import axios from 'axios'

import { BASE_URL } from '@/api/api.constants'
import { SpendLensItemsResponseModel } from '@/types/clarityLens'

export const getSpendLensItems = async (
  branchName: string,
  startDate: string,
  endDate: string,
  category: string
): Promise<SpendLensItemsResponseModel[]> => {
  try {
    const response = await axios.get(`${BASE_URL}/spend-lens/items`, {
      params: {
        start_date: startDate,
        end_date: endDate,
        dcn: branchName,
        category: category,
      },
    })

    return response.data?.items
  } catch (error) {
    throw error
  }
}
